import { Box, ExclamationCircleIcon, Typography } from '@forgeglobal/design-framework'
import React from 'react'

// Red text with a exclamation icon to be used in an infocard notes
export const CardWarningNotes = (props: { text: string }) => (
  <Box ml={1.0} display="flex" alignItems="center">
    <Typography variant="h5" color="error" display="inline" style={{ lineHeight: 'unset' }}>
      <ExclamationCircleIcon style={{ marginRight: 20, width: 16 }} />
    </Typography>
    <Typography variant="caption" color="error" display="inline" style={{ lineHeight: 'unset' }}>
      {props.text}
    </Typography>
  </Box>
)
